export type ShopLocale = string
export type ShopLanguage = 'it' | 'en'

export const SHOP_LOCALE_COOKIE = 'emporion_shop_locale'
export const DEFAULT_SHOP_LOCALE: ShopLocale = 'it-IT'
export const DEFAULT_ACTIVE_SHOP_LOCALES: ShopLocale[] = ['it-IT']

export type LocaleResolutionOptions = {
  availableLocales?: ShopLocale[]
}

export const FALLBACK_LOCALE_BY_LANGUAGE: Record<ShopLanguage, ShopLocale> = {
  it: 'it-IT',
  en: 'en-US',
}

export const LOCALE_ALIASES: Record<string, ShopLocale> = {
  it: 'it-IT',
  'it-it': 'it-IT',
  en: 'en-US',
  'en-us': 'en-US',
}

export const LOCALE_CODE_REGEX = /^[a-z]{2,3}(?:-[A-Za-z0-9]{2,8})*$/i

export const INTERNAL_BYPASS_PATHS = new Set(['admin', 'login', 'signup', 'dashboard', 'api'])
